import React from 'react';
import FederalFilingSection from './FederalFilingSection';

const BusinessFedReturnsSubmitted = () => <FederalFilingSection business />;
export default BusinessFedReturnsSubmitted;
